
export class Orders {

    order_id: any;
    flight_start_dt: any;
    flight_start_dt_sortable: any;
    agencyName: any;
    advertiser_name: any;
    total_order_amount: number;
    totalorderamount: number;
    agencyId: string;
    advertiserId: string;
    station_name:any;

}

export class OrderDetail {
    ordGrossAmountACH: string;
    ordAgencyamountACH: string;
    ordNetDiscountACH: string;
    ordTotalNetDiscountACH: string;
    ordTaxACH: string;
    ordGrossAmountCC: string;
    ordAgencyamountCC: string;
    ordNetDiscountCC: string;
    ordTaxCC: string;
    ordTotalNetDiscountCC: string;
}

export class OrderInvoice {
    invoiceID: any;
    invoiceDate: any;
    invoiceDateSortable: any;
    agencyName: any;
    advertiserName: any;
    invoiceDueDate: any;
    invoiceDueDateSortable: any;
    previousBalanceAmt: number;
    invoiceAmount: number;
}

export class SelectedRecords {
    invoiceid: string;
    invoicedate: string;
    invoiceamount: string;
    RecordType: string;
    agencyName: any;
    advertiserName: any;
}

export class TransactionHistory {

    TransactionHistoryId: number;
    orderId: string;
    invoiceId: string;
    invoiceDate: any;
    orderDate: any;
    agencyId: number;
    advertiserId: number;
    dueDate: any;
    totalAmount: number;
    transactionAmount: number;
    chaseOrderId: number;
    createdBy: number;
    agencyComm: any;
    tax: any;
    isCreateNewProfile: any;
    isPartialPayment: any;
    partialAmount: number;
    //   for Station Name in report
    station: any;
}

export class TransactionHistoryUpdate {

    chaseOrderId: string;
    transactionAmount: string;
    isPartialPayment: boolean;
    partialAmount: string;
    // Ar Adding to capture ACH and CC amount.
    ordTotalNetDiscountACH: string;
    ordTotalNetDiscountCC:string;
}

//   1234 for save transaction 

export class SaveTransaction {

    PaymentTransID: number;
    orderId: string;
    invoiceId: string;
    invoiceDate: any;
    orderDate: any;
    agencyId: number;
    advertiserId: number;
    totalAmount: number;
    transactionAmount: number;
    chaseOrderId: number;
    createdBy: number;
    tax: any;
    isPartialPayment: any;
    Isprocessed: any;
}